module.exports = __webpack_public_path__ + "static/media/youtube_color.0af810fd.svg";